import { useDefaultModuleActions } from "../../common"
import { Standards } from "../../../features/data-types"
import { DynamoUserApi } from "../../../services"
import { TableName } from "../../../tables"
import { define } from "../../../utils/typeUtils"
import { useSystemStateHooks } from "../../system"
import { ExpenseType } from "../state/types"
import { useExpenseTypeLoaders } from "../loaders/expenseTypeLoaders"

export const useExpensesActions = () => {
    const stateCompanyId = useSystemStateHooks().companyId

    const expenseTypeLoaders = useExpenseTypeLoaders()

    const defaultModuleActions = useDefaultModuleActions()

    return (paramCompanyId?: string) => {
        const companyId = paramCompanyId || stateCompanyId
        const { fetchByIds, count, save, remove } = defaultModuleActions(DynamoUserApi, define(companyId))

        const saveExpenseType = (expenseType: ExpenseType) => {
            return save(TableName.EXPENSE_TYPES, expenseType)
        }

        const removeExpenseType = async (id: string) => {
            const { loadAllExpenseTypes } = expenseTypeLoaders(companyId)
            const expenseTypes = await loadAllExpenseTypes()
            const expenseType = expenseTypes.find(expenseType => expenseType.id === id)
            const isSalary = expenseType?.name === Standards.SalaryExpenseTypeName
            if (expenseTypes.length > 1 && !isSalary) {
                return remove(TableName.EXPENSE_TYPES, id)
            }
        }

        const fetchExpenses = (ids: string[]) => {
            return fetchByIds(TableName.EXPENSES, ids)
        }

        const countExpenses = (propName: string, propValue: string) => {
            return count(TableName.EXPENSES, undefined, 1, { [propName]: propValue })
        }

        return {
            saveExpenseType,
            removeExpenseType,
            fetchExpenses,
            countExpenses
        }
    }
}
